import { ChangeEvent } from 'react';
import {
  SubmitHandler,
  Validate,
  ValidationRule,
  ValidationValueMessage,
} from 'react-hook-form';

import {
  HelpLink,
  SegmentedControlOptions,
  SelectOptions,
} from 'scenes/common/components/Questions';

export interface SingleFieldStepProps<VT> {
  question: string;
  stateKey: string;
  helpText?: string | JSX.Element;
  helpLink?: HelpLink;
  defaultStateValue: VT;
  onNext: SubmitHandler<Record<string, unknown>>;
  onClickSaveQuoteModal?: () => void;
  validationRules?:
    | Partial<{
        required: string | boolean | ValidationValueMessage<boolean>;
        min: ValidationRule<React.ReactText>;
        max: ValidationRule<React.ReactText>;
        maxLength: ValidationRule<React.ReactText>;
        minLength: ValidationRule<React.ReactText>;
        pattern: ValidationRule<RegExp>;
        validate: Validate | Record<string, Validate>;
      }>
    | undefined;
}

export interface SingleSegmentedControlStepProps<LT, VT>
  extends SingleFieldStepProps<VT> {
  options: SegmentedControlOptions<LT, VT>;
  stack?: boolean;
  onChangeCallback?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export interface SingleSelectStepProps extends SingleFieldStepProps<string> {
  ariaLabel?: string;
  options: SelectOptions;
  required?: boolean;
}

export enum AriaLive {
  assertive = 'assertive',
  polite = 'polite',
  off = 'off',
}
